import SwiperComponent from '@/js/core/SwiperComponent'
import Swiper from 'swiper'

export default class FilterPills extends SwiperComponent {
  static root = '[data-filters]'

  state = {
    ...this.state,
    breakpointWatch: true,
  }

  addSwiper () {
    const {
      swiperContainer,
      swiperScrollbar,
    } = this.$els

    this.swiper = new Swiper(swiperContainer, {
      freeMode: true,
      spaceBetween: 15,
      slidesPerView: 'auto',
      freeModeMomentumBounce: false,
      observeParents: true,
      observer: true,
      scrollbar: {
        el: swiperScrollbar,
      },
    })
  }
}